import { BaseFetch } from "../main-model"
export default class ReportInsuranceModel extends BaseFetch {
    getReportInsuranceBy = (data) =>
    this.authFetch({
      url: "report-insurance/getReportInsuranceBy",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportInsuranceById = (data) =>
    this.authFetch({
      url: "report-insurance/getReportInsuranceById",
      method: "POST",
      body: JSON.stringify(data),
    })
    insertReportInsurance = (data) =>
    this.authFetch({
      url: "report-insurance/insertReportInsurance",
      method: "POST",
      body: JSON.stringify(data),
    })
    updateReportInsuranceById = (data) =>
    this.authFetch({
      url: "report-insurance/updateReportInsuranceById",
      method: "POST",
      body: JSON.stringify(data),
    })
    deleteReportInsuranceById = (data) =>
    this.authFetch({
      url: "report-insurance/deleteReportInsuranceById",
      method: "POST",
      body: JSON.stringify(data),
    })
    getReportInsuranceAllBy = (data) =>
    this.authFetch({
      url: "report-insurance/getReportInsuranceAllBy",
      method: "POST",
      body: JSON.stringify(data),
    })

}
